import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { nomService } from '../../services/api/nom.service';
import { reportService } from '../../services/api/report.service';
import { utils } from "../../services/helpers/utils";


export const PatientMMRecords = ({ cnp, activeComponent, searchCode }) => {

    const [fise, setFise] = useState([]);
    const navigate = useNavigate();
    const partener = sessionStorage.getItem('idPartener');

    useEffect(() => {
        if (cnp) {
            nomService.getMMRecords({code: cnp, partener: partener })
                .then(response => {
                    if (response) {
                        setFise(response);
                    }
                    else {
                        setFise(null);
                    }
                });
        }
    }, [cnp]);

    const handleView = (page, param, value) => {

        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }


    const handleExport = () => {
        reportService.RaportCautarePacientFiseMM({ Code: cnp, Partener: 0 }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }



    return (
        <>
            {fise &&
                <>
                    <p className="paragraf">Fise anterioare MM:</p>
                    <table className="tbl" data-name="lista" width="100%">
                        <thead>
                            <tr>
                                <th>Nr</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Tip fisa</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Partener</th>
                                <th className="tac">Vezi fisa</th>
                            </tr>
                        </thead>
                    <tbody>
                        {fise.map((fisa, index) => (
                            <tr key={index}>
                                <td data-name="nr_crt" className="center"> {index + 1} </td>
                                <td data-name="nume_firma">{ fisa.denumireFirma}</td>
                                <td data-name="nume_profil">
                                    {fisa.denumireProfil}
                                    {fisa.firmaMaster && <span> (</span>}
                                    {fisa.firmaMaster}
                                    {fisa.firmaMaster && <span>)</span>}
                                </td>
                                <td data-name="tip_fisa"> { fisa.tip}</td>
                                <td data-name="status" className="center">{ fisa.status }</td>
                                <td data-name="dataora_inregistrare" className="center">{fisa.adaugatLa}</td>
                                <td data-name="partener" className="center">{ fisa.numePartener } </td>
                                <td>
                                    <a className="icon deschide m0auto"
                                        onClick={() => handleView("fisa-mm", "id", fisa.idFisa)}
                                        title="Vezi fisa"
                                        data-name="view">Vizualizare</a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div data-name="export">
                    <button data-name="btn-export" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};